import { Directive } from '@angular/core';
import { FormGroup, UntypedFormControl, ValidatorFn } from '@angular/forms';
import { StringUtils } from 'DiscoveryEngine.TS/Utils';

@Directive()
export class ComponentBase {

	constructor() {
		return;
	}

	protected hidePassword(pw: string): string {
		if (StringUtils.IsObfuscatedString(pw)) {
			let pwLength = StringUtils.ClarifyString2(pw).length;
			return StringUtils.Repeat('*', pwLength)
		}
		else {
			console.error('Password is not obfuscated');
			throw new Error('Password is not obfuscated');
		}
	}

	protected singleChar(): ValidatorFn {
		return (c: UntypedFormControl) => {
			let v = c.value;
			if (typeof (v) === "string" && v.length == 1)
				return null;
			else
				return {
					singleChar: { valid: false }
				};
		};
	}

	protected minValue(min: number): ValidatorFn {
		return (c: UntypedFormControl) => {
			let v = c.value;
			if (v === undefined || v === "")
				return null;
			if (typeof (v) === "string")
				v = v.trim();
			if (v === "")
				return null;

			if (/^\d+$/.test(v)) {
				let n = parseInt(v);
				if (n >= min) {
					return null;
				}
			}

			return {
				minValue: { valid: false }
			};
		};
	}

	protected maxValue(max: number): ValidatorFn {
		return (c: UntypedFormControl) => {
			let v = c.value;
			if (v === undefined || v === "")
				return null;
			if (typeof (v) === "string")
				v = v.trim();
			if (v === "")
				return null;

			if (/^\d+$/.test(v)) {
				let n = parseInt(v);
				if (n <= max) {
					return null;
				}
			}

			return {
				maxValue: { valid: false }
			};
		};
	}

	protected equalTo(a: UntypedFormControl, b: UntypedFormControl, key: string): ValidatorFn {
		return () => {
			if (!a.value && !b.value) {
				return null;
			}
			if (a.value == b.value) {
				return null;
			}
			else {
				let result = {};
				result[key] = { valid: false };
				return result;
			}
		};
	}

	protected notEmpty(): ValidatorFn {
		return (c: UntypedFormControl) => {
			let v = c.value;
			if (v === undefined || v === null || v === "" ||
				(Array.isArray(v) && v.length == 0)) {
				return {
					notEmpty: { valid: false }
				};
			}
			else {
				return null;
			}
		};
	}

	protected timePrecedes(a: UntypedFormControl, b: UntypedFormControl, key: string): ValidatorFn {
		return () => {
			let now = new Date();

			let aValue = <Date>a.value;
			let bValue = <Date>b.value;

			let aTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(),
				aValue.getHours(), aValue.getMinutes(), aValue.getSeconds(), aValue.getMilliseconds());
			let bTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(),
				bValue.getHours(), bValue.getMinutes(), bValue.getSeconds(), bValue.getMilliseconds());

			if (aTime <= bTime) {
				return null;
			}
			else {
				let result = {};
				result[key] = { valid: false };
				return result;
			}
		};
	}

	protected GetControlById(controlId: string): any {
		let control = null;
		if (document) {
			control = document.getElementById(controlId);
		}
		if (!control) {
			console.log("Could not find " + controlId);
		}
		return control;
	}

	protected EnableUIControl(controlId: string, isEnabled: boolean): void {
		let control = this.GetControlById(controlId);
		if (control) {
			if (isEnabled)
				control.removeAttribute("disabled");
			else
				control.setAttribute("disabled", "disabled");
		}
	}

	protected requiredIf(condition: () => boolean, key: string): ValidatorFn {
		return (field: UntypedFormControl) => {
			if (!condition()) {
				return null;
			}
			else if (!!field.value) {
				if (typeof field.value === "string") {
					let strFieldValue = <string>field.value;
					if (strFieldValue.trim().length > 0) {
						return null;
					}
				}
				else {
					return null;
				}
			}

			let result = {};
			result[key] = { valid: false };
			return result;
		};
	}

	protected isValidPort(key: string): ValidatorFn {
		return (field: UntypedFormControl) => {
			if (!!field.value) {
				let port = field.value;
				if (port > 0 && port < 65536) {
					return null;
				}
			}
			let result = {};
			result[key] = { valid: false };
			return result;
		};
	}

	protected enableDisableFormControl(control: UntypedFormControl, enabled: boolean) {
		if (enabled) {
			control.enable();
		}
		else {
			control.disable();
		}
	}

}
